const myStorage = window.localStorage;

export default {
  // A full quota (or blocked site data) must not break the page that saves.
  set: (key, value) => {
    try {
      myStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
      console.warn(`[storage] Could not save ${key}`, err?.name);
    }
  },
  get: (key) => JSON.parse(myStorage.getItem(key)),
  remove: (key) => myStorage.removeItem(key),
  clear: () => myStorage.clear()
}
